import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "authors",
  "use": "authors-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"authors\">\n<title></title>\n<g id=\"authors_icomoon-ignore\">\n</g>\n<path d=\"M184.32 757.76l-20.48 20.48v81.92h81.92l20.48-20.48-81.92-81.92zM266.24 675.84l81.92 81.92 512-512-81.92-81.92-512 512zM81.92 942.080v-204.8l696.32-696.32 204.8 204.8-696.32 696.32h-204.8zM409.6 942.080l81.92-81.92h450.56v81.92h-532.48z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol